import { Injectable, Injector } from '@angular/core';
import {
    ACondition,
    AObjectService,
    CacheService,
    ConfigurationService,
    MetadataService,
    PlatformService,
} from '@congacommerce/core';
import { Observable } from 'rxjs';
import { EglAssetLineItem } from '../../../../models/apttus/tables/user/egl-asset-line-item';
@Injectable()
export class EglAssetLineItemService extends AObjectService {
    constructor(
        cacheSrv: CacheService,
        plSrv: PlatformService,
        mtSrv: MetadataService,
        confSrv: ConfigurationService,
        inj: Injector,
    ) {
        super(cacheSrv, plSrv, mtSrv, confSrv, inj);
        this.setType(EglAssetLineItem);
    }

    getAssetLineItem(id: string): Observable<EglAssetLineItem> {
        const conditions = [new ACondition(this.type, 'Id', 'Equal', id)];
        const searchRecords$ = this.query({
            conditions: conditions,
            cacheStrategy: 'performance',
        });
        return searchRecords$;
    }
}
